<template>
    <div id="useMap" style="width:260px;height:230px;"></div>
</template>
<script>
export default {
    name:'usageDis',
    data(){
        return{
            
        }
    },
    props:['data'],
    watch:{
        data:{
            handler:function(){
                this.initEcharts();
            },
            deep:true,
        }
    },
    methods:{
        initEcharts(){
            var echarts = require('echarts');
            var myChart = echarts.init(document.getElementById('useMap'));
            var option ={
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {d}%'
                    },
                    series: [
                        {
                            name: '用途分布',
                            type: 'pie',
                            radius: ['40%', '90%'],
                            avoidLabelOverlap: false,
                            top:20,
                            bottom:20,
                            label: {
                                show: true,
                                position: 'outer',
                                color:'#B8D7FF'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '20',
                                    color:'#B8D7FF'
                                }
                            },
                            labelLine: {
                                show: true,
                                lineStyle: {
                                    color: '#B8D7FF'
                                }
                            },
                            data:this.data
                        }
                    ]
                }
            myChart.setOption(option);
        }
    }
}
</script>
<style lang="scss" scoped>

</style>


